

var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_shared-key.js
// module id = ../node_modules/core-js/modules/_shared-key.js
// module chunks = 0